import { StorageService } from './storage';

class NodeStorage implements Storage {
  [name: string]: any;
  readonly length: number = 0; // It's good practice to initialize readonly properties

  clear(): void {
    // Node.js typically doesn't have a global localStorage concept unless polyfilled.
    // This implementation remains a no-op for a basic Node environment.
  }

  getItem(key: string): string | null {
    return null;
  }

  key(index: number): string | null {
    return null;
  }

  removeItem(key: string): void {}

  setItem(key: string, value: string): void {}
}

const getLocalStorage = (): StorageService | null => {
  try {
    // Safely check if localStorage is defined
    if (typeof localStorage !== 'undefined' && localStorage !== null) {
      return new StorageService(localStorage);
    }
    // If not in a browser environment, use NodeStorage
    return new StorageService(new NodeStorage());
  } catch (e: any) {
    // This catch block might now be less likely to be hit for ReferenceError,
    // but good to keep for other potential errors during StorageService instantiation.
    console.warn('Error creating StorageService:', e);
    return null;
  }
};

export default getLocalStorage();
